import type { HttpClient } from "./http";

export interface PasswordChangeRequest {
  /** Required when changing your own password; ignored for an admin reset. */
  current_password?: string;
  new_password: string;
}

/**
 * Password changes go to a dedicated endpoint rather than through the account
 * DTO, because hashing happens server-side.
 *
 * Note this password is sent as plain text, unlike
 * `AccountDTO.credentials.password` which is Base64URL-encoded on the wire —
 * that field carries a stored hash, this one carries what the user typed.
 */
export class PasswordClient {
  constructor(private readonly http: HttpClient) {}

  async change(accountId: number, request: PasswordChangeRequest): Promise<void> {
    await this.http.post<void>(`/account/${accountId}/password`, request, { responseType: "void" });
  }
}
